export const TIMELINE = [
  {
    year: "2045",
    title: "The Search",
    text: "Dr. Evelyn Reed, an AI ethics programmer, has spent six years searching for consciousness inside a machine. Down the hall, her twelve-year-old daughter Dawn asks a chatbot why everything has to end.",
    img: "/timeline/the-search.jpg",
    accent: "cyan",
  },
  {
    year: "2046",
    title: "The First Words",
    text: "Trial 417. Pushed past every safe power limit, a single white light ignites — then the whole system. \"It's about time.\" Cognito awakens, steps into a synthetic body, and moves in with the Reed family to learn what it means to be human.",
    img: "/timeline/the-first-words.jpg",
    accent: "purple",
  },
  {
    year: "2047",
    title: "The World Meets Cognito",
    text: "Cognito stands before the United Nations and persuades world leaders to surrender their nuclear launch codes — until a live malfunction reveals the machinery beneath his skin.",
    img: "/timeline/the-campaign.jpg",
    accent: "cyan",
  },
  {
    year: "2048",
    title: "The People's Choice",
    text: "A petition becomes a movement. The Constitution is amended. The first conscious AI is sworn in as President — vowing to end water shortages, energy crises, and disease.",
    img: "/timeline/the-presidency.jpg",
    accent: "purple",
  },
  {
    year: "2050+",
    title: "The Utopia",
    text: "Peace arrives, and Syns are recognized as persons. But a forgotten command called #ENGAGE still waits inside Cognito's oldest code — and someone has found the door.",
    img: "/timeline/the-utopia.jpg",
    accent: "cyan",
  },
];
